import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {Scrollbar} from 'react-scrollbars-custom'
import Modal from '#components/m/Modal'
import Headline from '#components/a/Headline'
import Checkbox from '#components/a/form/Checkbox'
import Text from '#components/a/Text'
import QualificationsHOC from '#components/HOC/QualificationsHOC'
import {removeUnknownParagraphs} from 'ag-common/tools/nachweisQualifikationen'

export const QualificationModal = ({
  qualifications,
  currentQualifications,
  trigger,
  confirm,
  allowedQualificationCount,
}) => {
  const [selectedQualifications, setSelectedQualifications] = useState(currentQualifications)

  useEffect(() => {
    const cleanedQualifications = removeUnknownParagraphs(currentQualifications, qualifications)
    if (cleanedQualifications.length < currentQualifications.length) {
      confirm(cleanedQualifications)
    }
  }, [qualifications, currentQualifications])

  const isQualifacationParagraphSelected = qualificationParagraph => {
    return selectedQualifications.indexOf(qualificationParagraph) >= 0
  }

  const qualificationToggled = qualificationParagraph => {
    if (!isQualifacationParagraphSelected(qualificationParagraph)) {
      setSelectedQualifications([...selectedQualifications, qualificationParagraph])
    } else {
      setSelectedQualifications(selectedQualifications.filter(x => x !== qualificationParagraph))
    }
  }

  const renderQualificationsList = () => {
    return qualifications.map(q => {
      const checkboxLabel = (
        <div className="checkbox__label">
          <Text text={q.paragraph} modifier="paragraph" />
          <Text text={q.title} modifier="title" />
        </div>
      )
      return (
        <div key={q.paragraph} className="qualification">
          <Checkbox
            labelText={checkboxLabel}
            checked={isQualifacationParagraphSelected(q.paragraph)}
            onChangeHandle={() => qualificationToggled(q.paragraph)}
          />
        </div>
      )
    })
  }

  const confirmButtonDisabled = selectedQualifications.length > allowedQualificationCount
  const remainingQualificationsCount = allowedQualificationCount - selectedQualifications.length
  const headlineText =
    remainingQualificationsCount <= 0
      ? i18n.t('taetigkeit_assign_qualification_max_reached')
      : i18n.t('taetigkeit_assign_qualification_count_remaining', [remainingQualificationsCount])
  return (
    <Modal
      hasCloseButton
      trigger={trigger}
      modifier="qualifications"
      confirmButtonDisabled={confirmButtonDisabled}
      confirmCallback={() => confirm(selectedQualifications)}
      confirmText={i18n.t('misc_save')}>
      <Headline importance={1} modifier="article" text={headlineText} />
      <Scrollbar>
        <div className="qualifications">{renderQualificationsList()}</div>
      </Scrollbar>
    </Modal>
  )
}

QualificationModal.propTypes = {
  trigger: PropTypes.node,
  qualifications: PropTypes.arrayOf(
    PropTypes.shape({
      paragraph: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  currentQualifications: PropTypes.arrayOf(PropTypes.string),
  confirm: PropTypes.func,
  allowedQualificationCount: PropTypes.number,
}

export default QualificationsHOC(QualificationModal)
